import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/tencent-weibo': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9-11.6-129.9 31.1-239.5 101.4-313.2-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 0.1c92 0 166.6 74.6 166.6 166.5 0 102.3-93.3 185.5-204 162.3-19-4.7-12.5-33.2 6.6-29.1 80.8 20.8 167.7-42.3 167.7-133.1 0-75.5-61.5-136.9-136.9-136.9-101 0-168.3 106.6-122 199.2 9 17.9-17.6 30.8-26.3 13.4-56-108.1 22.4-242.3 148.3-242.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/tencent-weibo.js
// module id = 1052
// module chunks = 0